import { render, staticRenderFns } from "./RateProfile.vue?vue&type=template&id=5efe1f08&scoped=true"
import script from "./RateProfile.vue?vue&type=script&lang=js"
export * from "./RateProfile.vue?vue&type=script&lang=js"
import style0 from "./RateProfile.vue?vue&type=style&index=0&id=5efe1f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efe1f08",
  null
  
)

export default component.exports